module.exports = __webpack_public_path__ + "img/maj4.5a0ece3f.jpg";